module.exports = require('./helpers/bundle-url').getBundleURL('kQ46M') + "logo.7718c6df.svg";